import React from 'react';
import { View, Text, ActivityIndicator, Pressable } from 'react-native';
import useCampaignTranslation from '../../hooks/campaign-translation-hook';

export default function CampaignSecurityLoading({ failed, retry }: { failed: boolean; retry: () => void }) {
  const text = useCampaignTranslation();
  return <View style={{ flex: 1, padding: 24, justifyContent: 'center', backgroundColor: '#fff' }}>
    {failed ? <>
      <Text>{text('campaign-signup-error')}</Text>
      <Pressable onPress={retry} style={{ paddingVertical: 20 }}><Text>{text('campaign-retry')}</Text></Pressable>
    </> : <ActivityIndicator accessibilityLabel={text('campaign-loading')} />}
  </View>;
}
